import printJS from 'print-js';
import Vue from 'vue';
Vue.prototype.printJS = printJS;